module.exports = __webpack_public_path__ + "img/bottom-right-blop-mobile.81db18cf.svg";